export const blockIconsEditorInsertPhoto = (
	<span className='material-symbols-outlined'>insert_photo</span>
);
